import { cn, Icon } from "@kyan/ui";

import { isMainnet } from "#/config/web3/contractAddresses";
import { useBridgeState } from "#/store/app/equityModal/bridgeState";
import { useShowBridgeHistory } from "#/store/app/equityModal/showBridgeHistory";
import { useAccountState } from "#/store/wallet/account/accountState";

export const BridgeButton: React.FC = () => {
  const {
    transactions: bridgeTransactions,
    pendingTransactions: pendingBridgeTransactions,
  } = useBridgeState();
  const { setShowBridgeHistory } = useShowBridgeHistory();
  const { hasEquitySomewhere } = useAccountState();

  if (!bridgeTransactions.length || !isMainnet) return null;

  return (
    <button
      className={cn(
        "border-divider hover:bg-buttonHover absolute flex cursor-pointer items-center justify-center gap-1.5 rounded-lg border py-0.75 pr-1 pl-1.75 transition-colors",
        {
          "top-0 right-0": hasEquitySomewhere,
          "-top-2 right-7": !hasEquitySomewhere,
        },
      )}
      onClick={() => setShowBridgeHistory(true)}
    >
      <Icon size="xs" name="bridge" className="text-textSecondary my-1" />
      <span className="text-primary bg-primary/10 inline-flex size-4.5 items-center justify-center rounded-sm p-1 text-[13px] font-bold">
        {pendingBridgeTransactions.length}
      </span>
    </button>
  );
};
